__turbopack_context__.v({
  "activeTab": "Dashboard-module__DB7hEa__activeTab",
  "appTitle": "Dashboard-module__DB7hEa__appTitle",
  "chartCard": "Dashboard-module__DB7hEa__chartCard",
  "container": "Dashboard-module__DB7hEa__container",
  "header": "Dashboard-module__DB7hEa__header",
  "mainTemp": "Dashboard-module__DB7hEa__mainTemp",
  "settingsButton": "Dashboard-module__DB7hEa__settingsButton",
  "statsRow": "Dashboard-module__DB7hEa__statsRow",
  "status": "Dashboard-module__DB7hEa__status",
  "statusCold": "Dashboard-module__DB7hEa__statusCold",
  "statusComfortable": "Dashboard-module__DB7hEa__statusComfortable",
  "statusHot": "Dashboard-module__DB7hEa__statusHot",
  "tab": "Dashboard-module__DB7hEa__tab",
  "tabs": "Dashboard-module__DB7hEa__tabs",
  "tempLabel": "Dashboard-module__DB7hEa__tempLabel",
  "tempUnit": "Dashboard-module__DB7hEa__tempUnit",
  "tempValue": "Dashboard-module__DB7hEa__tempValue",
  "topBar": "Dashboard-module__DB7hEa__topBar",
  "updatedTime": "Dashboard-module__DB7hEa__updatedTime",
});
